<template lang="pug">
.speaker-card
  .speaker-card__photo-wrap(:style="speaker.photoUrl ? {} : { background: avatarColor }")
    img.speaker-card__photo(
      v-if="speaker.photoUrl"
      :src="speaker.photoUrl"
      :alt="speaker.name || 'Speaker photo'")
    .speaker-card__photo-fallback(v-else) {{ initials }}
  .speaker-card__info
    .speaker-card__name {{ speaker.name }}
    .speaker-card__title(v-if="speakerSubtitle") {{ speakerSubtitle }}
    div.speaker-card__bio(v-if="speaker.bio" v-html="bioHtml")
</template>

<script>
import { bioToHtml } from './sanitizeHtml.js';

export default {
  name: 'SessionSpeakerCard',

  props: {
    speaker: {
      type: Object,
      required: true,
    },
    colorIndex: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    bioHtml() {
      return bioToHtml(this.speaker.bio);
    },

    initials() {
      const parts = (this.speaker.name || '').split(' ').filter(Boolean);
      if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      return parts[0] ? parts[0][0].toUpperCase() : '';
    },

    avatarColor() {
      const colors = ['#2563EB', '#0F766E', '#10B981', '#036EBA'];
      return colors[this.colorIndex % colors.length];
    },

    speakerSubtitle() {
      return [this.speaker.title, this.speaker.organization].filter(Boolean).join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './tokens';

.speaker-card {
  background: white;
  border-radius: 12px;
  box-shadow: $shadow-card;
  padding: 24px;
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.speaker-card__photo-wrap {
  flex-shrink: 0;
  width: 120px;
  height: 120px;
  border-radius: 9999px;
  overflow: hidden;
  background: $color-primary-dark; // fallback; overridden by inline style for initials
  display: flex;
  align-items: center;
  justify-content: center;
}

.speaker-card__photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.speaker-card__photo-fallback {
  color: white;
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}

.speaker-card__info {
  flex: 1;
  min-width: 0;
}

.speaker-card__name {
  font-size: 18px;
  font-weight: 700;
  color: $color-text-dark;
  line-height: 1.35;
  margin-bottom: 4px;
}

.speaker-card__title {
  font-size: 13px;
  font-weight: 600;
  color: $color-text-secondary;
  margin-bottom: 12px;
  line-height: 1.3;
}

.speaker-card__bio {
  font-size: 16px;
  font-weight: 400;
  color: $color-text-secondary;
  line-height: 1.5;

  ::v-deep p {
    margin: 0;
    &:not(:last-child) { margin-bottom: 0.75em; }
  }
}

@media (max-width: 1023px) {
  .speaker-card {
    flex-direction: column;
    align-items: center;
  }
  .speaker-card__info {
    text-align: center;
    width: 100%;
  }
}
</style>
